
export const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3, STATUS_PROCESSING = 4;
export const TYPE_UPLOAD_PICTURE = 0, TYPE_UPLOAD_DOCUMENT = 1;